import React from 'react'
import { Link } from 'react-router-dom'

const ctat1 = ({Title, Message, Url, UrlTitle, Class}) => {
  return (
    <div className={Class}>
        <div className='ctat1_wrapper'>
            <h3>{Title}</h3>
            {
                Message.map((object, i) => {
                    return (<p key={i}> {object} </p>)
                })
            }
            <div className='ctat1_link'><Link to={Url}>{UrlTitle}</Link></div>
        </div>
    </div>
  )
}

export default ctat1
